import * as React from 'react'
import * as Customer from '../../../Entities/Customer'
import * as Company from '../../../Entities/Company'
import * as BpsUser from '../../../Entities/BpsUser'
import * as Nullable from '../../../Data/Nullable'
import {Step1State} from './Step1State'
import {Step1SubAction} from './Step1Actions'
import Card from 'material-ui/Card/Card'
import TextField from 'material-ui/TextField'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import RaisedButton from 'material-ui/RaisedButton'
import {
    renderSuggestion,
    renderSuggestionsContainer,
    shouldRenderSuggestions
} from '../../../View/MaterialAutosuggest'
import * as Autosuggest from 'react-autosuggest'
import TextFieldProps = __MaterialUI.TextFieldProps
import injectSheet from 'react-jss'
import {card} from '../../../Style'

const styles = {
    root: {
        display: 'flex',
        justifyContent: 'center'
    },
    ...card
}

interface Props {
    readonly state: Step1State,
    readonly dispatch: (action: Step1SubAction) => void
}

export const Step1View =
    injectSheet<Props>(styles)(
        ({classes, state, dispatch}) => (
            <div className={classes.root}>
                <Card
                    className={classes.card}
                    style={{
                        maxWidth: '1536px'
                    }}
                >
                    <div className={classes.cardRow}>
                        <div className={classes.cardColumn}>
                            <h2 className={classes.cardHeader}>Informationen</h2>
                            <div className={classes.cardContent}>

                                <TextField
                                    floatingLabelText="Externe Auftragsnummer"
                                    fullWidth={true}
                                    value={state.input.transactionNumber}
                                    onChange={(event, value) => dispatch({
                                        type: 'TransactionNumberChanged',
                                        value
                                    })}
                                />
                                <CustomerSelect
                                    state={state}
                                    dispatch={dispatch}
                                />
                                <CompanySelect
                                    state={state}
                                    dispatch={dispatch}
                                />
                                <BpsUserSelect
                                    state={state}
                                    dispatch={dispatch}
                                />
                            </div>
                        </div>
                        <div className={classes.divider}/>
                        <div className={classes.cardColumn}>
                            <h2 className={classes.cardHeader}>Hinweise (optional)</h2>
                            <div className={classes.cardContent}>
                                <TextField
                                    floatingLabelFixed={true}
                                    floatingLabelText="Hinweistext"
                                    multiLine={true}
                                    hintText="Ihr Text"
                                    fullWidth={true}
                                    rows={5}
                                />
                                <RaisedButton
                                    label="Datei hinzufügen"
                                    primary={true}
                                    style={{marginTop: '20px'}}
                                />
                            </div>
                        </div>
                    </div>
                </Card>
            </div>)
    )

function CustomerSelect({state, dispatch}: {
    state: Step1State,
    dispatch: (action: Step1SubAction) => void,
}) {
    switch (state.customers.type) {
        case 'Loading':
            return (
                <SelectField
                    floatingLabelText="Lade Kundenliste.."
                    fullWidth={true}
                    disabled={true}
                />)
        case 'Failure':
            return (
                <SelectField
                    floatingLabelText="Fehler beim Laden"
                    fullWidth={true}
                    disabled={true}
                />)
        case 'Success':
            return (
                <SelectField
                    floatingLabelText="Kunde"
                    value={
                        Nullable.map(
                            customer => customer.id,
                            state.input.customer)}
                    fullWidth={true}
                    errorText={
                        state.validation.customer === 'Mandatory' ?
                            'Kunde ist ein Pflichtfeld' :
                            null}
                    onChange={(event, key, value: number | null) =>
                        dispatch({
                            type: 'CustomerIdChanged',
                            value,
                        })}
                >
                    {state.customers.value.map(customer =>
                        <MenuItem
                            value={customer.id}
                            primaryText={Customer.label(customer)}
                            key={customer.id}
                        />
                    )}
                </SelectField>
            )
    }
}

function CompanySelect({state, dispatch}: {
    state: Step1State,
    dispatch: (action: Step1SubAction) => void,
}) {
    return (
        <Autosuggest
            suggestions={state.companySuggestions}
            onSuggestionsFetchRequested={
                (value: string) => dispatch({
                    type: 'FetchCompanySuggestions',
                    value,
                })}
            onSuggestionsClearRequested={
                () => dispatch({
                    type: 'ClearCompanySuggestions',
                })}
            getSuggestionValue={Company.label}
            inputProps={{
                value: state.companySearch,
                onChange: (// tslint:disable-next-line
                    event: any,
                    {newValue}: { newValue: string }) => dispatch({
                    type: 'CompanySearchChanged',
                    value: newValue,
                }),
            }}
            onSuggestionSelected={
                (// tslint:disable-next-line
                    event: any,
                    {suggestion}: { suggestion: Company.Company }) => dispatch({
                    type: 'CompanyChanged',
                    value: suggestion,
                })}
            renderInputComponent={
                (inputProps: TextFieldProps) =>
                    state.input.customer !== null ?
                        <TextField
                            {...inputProps}
                            floatingLabelText="Gesellschaft"
                            errorText={
                                state.validation.company === 'Mandatory' ?
                                    'Gesellschaft ist ein Pflichtfeld' :
                                    null}
                            fullWidth={true}
                        /> :
                        <TextField
                            {...inputProps}
                            floatingLabelText="Bitte erst Kunde auswählen"
                            disabled={true}
                            fullWidth={true}
                        />
            }
            renderSuggestionsContainer={renderSuggestionsContainer}
            renderSuggestion={renderSuggestion(Company.label)}
            shouldRenderSuggestions={shouldRenderSuggestions}
        />)
}

function BpsUserSelect({state, dispatch}: {
    state: Step1State,
    dispatch: (action: Step1SubAction) => void,
}) {
    return (
        <Autosuggest
            suggestions={state.bpsUserSuggestions}
            onSuggestionsFetchRequested={
                (value: string) => dispatch({
                    type: 'FetchBpsUserSuggestions',
                    value,
                })}
            onSuggestionsClearRequested={
                () => dispatch({
                    type: 'ClearBpsUserSuggestions',
                })}
            getSuggestionValue={BpsUser.label}
            inputProps={{
                value: state.bpsUserSearch,
                onChange: (// tslint:disable-next-line
                    event: any,
                    {newValue}: { newValue: string }) => dispatch({
                    type: 'BpsUserSearchChanged',
                    value: newValue,
                }),
            }}
            onSuggestionSelected={
                (// tslint:disable-next-line
                    event: any,
                    {suggestion}: { suggestion: BpsUser.BpsUser }) => dispatch({
                    type: 'BpsUserChanged',
                    value: suggestion,
                })}
            renderInputComponent={
                (inputProps: TextFieldProps) =>
                    state.input.company !== null ?
                        <TextField
                            {...inputProps}
                            floatingLabelText="Besteller"
                            errorText={
                                state.validation.bpsUser === 'Mandatory' ?
                                    'Besteller ist ein Pflichtfeld' :
                                    null}
                            fullWidth={true}
                        /> :
                        <TextField
                            {...inputProps}
                            floatingLabelText="Bitte erst Gesellschaft auswählen"
                            disabled={true}
                            fullWidth={true}
                        />
            }
            renderSuggestionsContainer={renderSuggestionsContainer}
            renderSuggestion={renderSuggestion(BpsUser.label)}
            shouldRenderSuggestions={shouldRenderSuggestions}
        />)
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/OrderCreate/Step1/Step1View.tsx